import React from 'react';
import PropTypes from 'prop-types';

function ChoiceChip(props) {
  const {
    label,
    value,
    isActive,
    onValueSelected,
  } = props;

  const activeChoiceChipClass = isActive ? 'at-button--selected' : '';

  return (
    <button
      key={value}
      type="button"
      className={`at-button ${activeChoiceChipClass} at-button--rounded at-button--cards at-font__button at-px-4 at-py-2 at-py-md-3 at-border--none at-d-flex`}
      onClick={() => onValueSelected(value)}
    >
      {isActive && (
        <svg aria-label="selected" className="at-icon at-me-1">
          <use href="#icon-success-in-a-circle" />
        </svg>
      )}
      {label}
    </button>
  );
}

ChoiceChip.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  isActive: PropTypes.bool,
  onValueSelected: PropTypes.func,
};

ChoiceChip.defaultProps = {
  label: '',
  value: '',
  isActive: 'tab--active',
  onValueSelected: () => { /* default empty function */ },
};

export default ChoiceChip;
